<template>
    <v-container>
        <v-row>
            <v-col>
                <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="selectedDate" color="#c42111" label="Date" prepend-icon="event" readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="selectedDate" color="#c42111" @input="dateMenu = false" @change="onChange" no-title scrollable />
                </v-menu>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'Date',
  props: ['param'],
  data: () => ({
      selectedDate: TELSA.moment().subtract(1, 'days').format("YYYY-MM-DD"),
      dateMenu: false,
  }),

  computed: {
    
  },

  methods: {
      onChange: function() {
          this.param.selectedValue = `${this.selectedDate}`;
          this.param.humanText = `${this.selectedDate}`;

          this.$emit('edit');
      },

      setInputsInitialValue: function() {
          if(this.$props.param.encodedValue == undefined) {
              return;
          }
          this.selectedDate = TELSA.moment(this.$props.param.encodedValue).format("YYYY-MM-DD");
      }
  },

  mounted() {
      this.setInputsInitialValue();
      this.onChange();
  }

  
};
</script>

<style scoped>

</style>

